import { ContainerComponent, wrap } from 'AppReact';
import {
  FlexCenterBetweenWrapper, FlexCenterWrapper, Mr5, GenericWrapper, Mr2
} from 'wrappers';
import { TagInput, TagText, ClickableIcon } from 'atoms';
import Controller from './controller';
import internalState from './internalState';
import { IconTextButton, TagColorSelect } from 'molecules';
import { tagColors } from 'utils';
import { ColorPickerSvg, EditPencilSvg, TrashBinSvg, TickSvg } from 'components/icons';

export const definition = {
  name: 'InputWithTextButton',
  initialProps: ({ tag, maxLength, tagInputRef }) => ({ tagInputRef, tag, color: tag?.color ?? '', value: tag?.name ?? '', maxLength }),
  props: internalState,
  controller: Controller,
  elements: [
    {
      wrapper: FlexCenterBetweenWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef ?? null,
      elements: [
        {
          wrapper: GenericWrapper,
          name: 'InputWrapper',
          renderIf: ({ isEditingName }) => isEditingName,
          ref: ({ inputRef }) => inputRef ?? null,
          elements: [
            {
              component: TagInput,
              name: 'TagInput',
              displayState: ({ color }) => ({ color }),
              bindings: ({ tagInputRef, value, maxLength, tag, color }) => {
                return ({ tagInputRef, tag, color, maxLength, value, placeholder: 'Tag name' })
              }
            },
          ]
        },
        {
          component: TagText,
          name: 'TagText',
          renderIf: ({ isEditingName }) => !isEditingName,
          displayState: ({ color }) => ({ color }),
          displayValue: ({ value }) => value
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'ColorsWrapper',
          renderIf: ({ value, isEditingName, isEditingColor }) => (!!value && isEditingName) || isEditingColor,
          elements: [
            {
              component: wrap(TagColorSelect, Mr2),
              name: 'TagColorSelect',
              renderIf: ({ isEditingColor }) => isEditingColor,
              isListOf: { tagColor: ({ }) => tagColors },
              bindings: ({ color, tagColor, tagInputRef, tag }) => ({ tagInputRef, tag, color: tagColor, isSelected: color === tagColor }),
              displayState: ({ tagColor }) => ({ color: tagColor })
            },
            {
              component: IconTextButton,
              name: 'SaveButton',
              bindings: ({ value, color, tag }) => ({ tag, color, value, icon: TickSvg({ square: true }), title: 'Save' })
            },
          ]
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'Buttons',
          renderIf: ({ isEditingName, isEditingColor }) => !isEditingColor && !isEditingName,
          elements: [
            {
              component: wrap(ClickableIcon, Mr5),
              name: 'Color',
              bindings: ({ containerRef, tag }) => ({ containerRef, tag }),
              displayValue: ({ }) => ColorPickerSvg({ width: 22, height: 22, color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: wrap(ClickableIcon, Mr5),
              name: 'Name',
              bindings: ({ inputRef, containerRef, tag }) => ({ inputRef, containerRef, tag }),
              displayValue: ({ }) => EditPencilSvg({ width: 18, height: 18, color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: ClickableIcon,
              name: 'Delete',
              bindings: ({ }) => ({}),
              displayValue: ({ }) => TrashBinSvg({ width: 18, height: 18, color: window?.settings?.primary_color ?? '#1DBD6B' })
            }
          ]
        }
      ]
    }
  ]
}

export default ContainerComponent(definition);